"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.leaveRequestTemplate = void 0;
const variables_1 = require("@whispir/variables");
const templateUtils_1 = require("../../templateUtils");
const triggerFormContent = {
    subject: 'Leave Request',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: '38da75c6-a77a-4a87-b261-f75123e74648',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/leave_request_form_678.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: 'c2437ae7-c25e-499e-afb4-66209937509a',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>Use this form to request leave. Once submitted, Human Resources will process your request and provide you with a response.</p>',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: '602cb9b1-8158-4fec-a78e-02744ea38cab',
            data: {
                backgroundColor: '#ffffff',
                label: 'Full Name',
                requiredField: true,
                helperText: '',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: '',
                textInputType: 'text',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: '59ea92aa-9524-4b4b-a94b-22915c4623d7',
            data: {
                backgroundColor: '#ffffff',
                label: 'Phone Number',
                requiredField: true,
                helperText: '',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: '',
                textInputType: 'tel',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: '8800edb3-90e2-4941-b959-9caf7334105b',
            data: {
                backgroundColor: '#ffffff',
                label: 'Email Address',
                requiredField: true,
                helperText: '',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: '',
                textInputType: 'email',
            },
        },
        {
            type: 'form-dropdown',
            version: '1',
            id: '2ce1a8ae-fac6-4eed-bd41-1c6a47a6fb18',
            data: {
                backgroundColor: '#FFFFFF',
                label: 'Department',
                requiredField: true,
                helperText: '',
                options: [
                    {
                        id: '8b2b35ee-30de-4159-b7a8-70ae8f6a04d5',
                        label: 'Accounts',
                        value: false,
                    },
                    {
                        id: 'c2e1a72c-6d50-4d47-903a-4880e2c8d100',
                        label: 'Human Resources',
                        value: false,
                    },
                    {
                        id: '110b69cd-80f5-4c44-8c63-03a4d37cb244',
                        label: 'Production',
                        value: false,
                    },
                    {
                        id: '563780c6-4e7c-4620-a475-9d0c9255e89c',
                        label: 'Purchasing',
                        value: false,
                    },
                    {
                        id: '2e5e4590-610d-44c9-9770-d0cd2b3b05c9',
                        label: 'Sales',
                        value: false,
                    },
                    {
                        id: 'e759421a-34e5-4e0b-82ee-1c0b824b6d85',
                        label: 'Marketing',
                        value: false,
                    },
                ],
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
        {
            type: 'display-divider',
            version: '1',
            id: 'b6ceab87-aba0-4469-bff0-ce832bcd2513',
            data: {
                borderStyle: 'solid',
                borderWidth: 1,
                dividerWidth: 100,
                dividerAlign: 'center',
                dividerColor: '#000',
                backgroundColor: '#FFFFFF',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
        {
            type: 'form-dropdown',
            version: '1',
            id: '88b8ac52-5bf5-45fb-b4c0-5795b02524d8',
            data: {
                backgroundColor: '#FFFFFF',
                label: 'Leave Type',
                requiredField: true,
                helperText: '',
                options: [
                    {
                        id: '8b2b35ee-30de-4159-b7a8-70ae8f6a04d5',
                        label: 'Annual Leave',
                        value: false,
                    },
                    {
                        id: 'c2e1a72c-6d50-4d47-903a-4880e2c8d100',
                        label: 'Personal or Sick Leave',
                        value: false,
                    },
                    {
                        id: '110b69cd-80f5-4c44-8c63-03a4d37cb244',
                        label: 'Birthday Leave',
                        value: false,
                    },
                    {
                        id: '563780c6-4e7c-4620-a475-9d0c9255e89c',
                        label: 'Time in Lieu',
                        value: false,
                    },
                    {
                        id: '2e5e4590-610d-44c9-9770-d0cd2b3b05c9',
                        label: 'Compassionate Leave',
                        value: false,
                    },
                    {
                        id: 'e759421a-34e5-4e0b-82ee-1c0b824b6d85',
                        label: 'Parental Leave',
                        value: false,
                    },
                    {
                        id: 'cfe4c070-6fc0-4590-ac2d-81f754416328',
                        label: 'Unpaid Leave',
                        value: false,
                    },
                    {
                        id: '88470dd8-3b1e-47e0-8203-96ce2c0cf1e8',
                        label: 'Long Service Leave',
                        value: false,
                    },
                ],
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
        {
            type: 'form-date-input',
            version: '1',
            id: 'f927f1ee-ea57-4664-b5d7-ad0cd73c4044',
            data: {
                backgroundColor: '#ffffff',
                label: 'Leave Date Start',
                requiredField: true,
                helperText: 'Pick your date',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                defaultValue: '',
                currentDateAsDefault: false,
                format: 'dd/MM/yy',
            },
        },
        {
            type: 'form-date-input',
            version: '1',
            id: '9d34cd0c-6f96-4360-896b-a7a2c313f294',
            data: {
                backgroundColor: '#ffffff',
                label: 'Leave Date End',
                requiredField: true,
                helperText: 'Pick your date',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                defaultValue: '',
                currentDateAsDefault: false,
                format: 'dd/MM/yy',
            },
        },
        {
            type: 'form-text-area',
            version: '1',
            id: 'ef4a23b3-348e-468d-b360-e768ee3bfc46',
            data: {
                backgroundColor: '#ffffff',
                label: 'Reason for leave',
                requiredField: true,
                helperText: '',
                defaultValue: '',
                inputFieldHeight: 4,
                placeholder: 'Enter Text',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
        {
            type: 'form-submit-button',
            version: '1',
            id: '78c70729-0583-4ba2-b11f-9515e62b75a7',
            data: {
                backgroundColor: '#FFFFFF',
                borderColor: '#13DB81',
                borderRadius: 4,
                buttonColor: '#13DB81',
                color: '#FFFFFF',
                fontSize: 14,
                paddingBottom: 10,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 10,
                text: 'Submit Leave Request',
                textAlign: 'center',
                width: 600,
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: 'd363550c-3e95-4aed-b057-74d4c9cc4aa7',
            data: {
                text: '<p>Powered by Workflows</p>',
                position: 'middle-middle',
                color: '#838383',
                textPadding: 0,
                src: 'https://cdn-au.whispir.com/public/resources/313a588f0b0ae6c3caa57f6536a540ab50.jpeg',
                backgroundColor: '#F3F3F3',
                height: 50,
                fullWidth: false,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    ],
    inputVariables: [],
    outputVariables: [
        {
            id: '602cb9b1-8158-4fec-a78e-02744ea38cab',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Full Name',
        },
        {
            id: '59ea92aa-9524-4b4b-a94b-22915c4623d7',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Phone Number',
        },
        {
            id: '8800edb3-90e2-4941-b959-9caf7334105b',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Email Address',
        },
        {
            id: '2ce1a8ae-fac6-4eed-bd41-1c6a47a6fb18',
            valueType: 'string',
            inputType: 'form-dropdown',
            label: 'Department',
            options: [
                {
                    id: '8b2b35ee-30de-4159-b7a8-70ae8f6a04d5',
                    label: 'Accounts',
                    value: false,
                },
                {
                    id: 'c2e1a72c-6d50-4d47-903a-4880e2c8d100',
                    label: 'Human Resources',
                    value: false,
                },
                {
                    id: '110b69cd-80f5-4c44-8c63-03a4d37cb244',
                    label: 'Production',
                    value: false,
                },
                {
                    id: '563780c6-4e7c-4620-a475-9d0c9255e89c',
                    label: 'Purchasing',
                    value: false,
                },
                {
                    id: '2e5e4590-610d-44c9-9770-d0cd2b3b05c9',
                    label: 'Sales',
                    value: false,
                },
                {
                    id: 'e759421a-34e5-4e0b-82ee-1c0b824b6d85',
                    label: 'Marketing',
                    value: false,
                },
            ],
        },
        {
            id: '88b8ac52-5bf5-45fb-b4c0-5795b02524d8',
            valueType: 'string',
            inputType: 'form-dropdown',
            label: 'Leave Type',
            options: [
                {
                    id: '8b2b35ee-30de-4159-b7a8-70ae8f6a04d5',
                    label: 'Annual Leave',
                    value: false,
                },
                {
                    id: 'c2e1a72c-6d50-4d47-903a-4880e2c8d100',
                    label: 'Personal or Sick Leave',
                    value: false,
                },
                {
                    id: '110b69cd-80f5-4c44-8c63-03a4d37cb244',
                    label: 'Birthday Leave',
                    value: false,
                },
                {
                    id: '563780c6-4e7c-4620-a475-9d0c9255e89c',
                    label: 'Time in Lieu',
                    value: false,
                },
                {
                    id: '2e5e4590-610d-44c9-9770-d0cd2b3b05c9',
                    label: 'Compassionate Leave',
                    value: false,
                },
                {
                    id: 'e759421a-34e5-4e0b-82ee-1c0b824b6d85',
                    label: 'Parental Leave',
                    value: false,
                },
                {
                    id: 'cfe4c070-6fc0-4590-ac2d-81f754416328',
                    label: 'Unpaid Leave',
                    value: false,
                },
                {
                    id: '88470dd8-3b1e-47e0-8203-96ce2c0cf1e8',
                    label: 'Long Service Leave',
                    value: false,
                },
            ],
        },
        {
            id: 'f927f1ee-ea57-4664-b5d7-ad0cd73c4044',
            valueType: 'date',
            inputType: 'form-date-input',
            label: 'Leave Date Start',
        },
        {
            id: '9d34cd0c-6f96-4360-896b-a7a2c313f294',
            valueType: 'date',
            inputType: 'form-date-input',
            label: 'Leave Date End',
        },
        {
            id: 'ef4a23b3-348e-468d-b360-e768ee3bfc46',
            valueType: 'string',
            inputType: 'form-text-area',
            label: 'Reason for leave',
        },
    ],
};
const leaveRequestConfirmationEmail = {
    subject: 'Your leave request has been received!',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: '90fdf8fd-a37c-42a7-aaf0-f2c964cb6eb7',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/pending_leave_request_678.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: 'e6a3d7c8-bccc-4099-a589-4e8e5ee9b197',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>Hi <span data-variableid="602cb9b1-8158-4fec-a78e-02744ea38cab">Full Name</span>,</p><p></p><p>Your leave request has been submitted and will be processed soon.</p><p></p><h2>Leave Request Details</h2><p></p><p><strong>Name:</strong> <span data-variableid="602cb9b1-8158-4fec-a78e-02744ea38cab">Full Name</span></p><p><strong>Phone:</strong><span data-variableid="59ea92aa-9524-4b4b-a94b-22915c4623d7">Phone Number</span></p><p><strong>Email Address:</strong> <span data-variableid="8800edb3-90e2-4941-b959-9caf7334105b">Email Address</span></p><p><strong>Department:</strong> <span data-variableid="2ce1a8ae-fac6-4eed-bd41-1c6a47a6fb18">Department</span></p><p><strong>Leave Type: </strong><span data-variableid="88b8ac52-5bf5-45fb-b4c0-5795b02524d8">Leave Type</span></p><p><strong>Leave Start Date:</strong> <span data-variableid="f927f1ee-ea57-4664-b5d7-ad0cd73c4044">Leave Date Start</span></p><p><strong>Leave End Date:</strong> <span data-variableid="9d34cd0c-6f96-4360-896b-a7a2c313f294">Leave Date End</span></p><p><strong>Reason for leave: </strong><span data-variableid="ef4a23b3-348e-468d-b360-e768ee3bfc46">Reason for leave</span></p><p><strong>Date Submitted:</strong> <span data-variableid="date">Current date e.g: yyyy/mm/dd</span></p><p></p><p>Leave requests are generally processed within 48 hours. You will receive an update on your request via email shortly.</p><p></p><p>Kind Regards,</p><p></p><p>Human Resources</p><p>Acme. Company.</p>',
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: '8e9de1e0-302a-427f-8dd9-0e4abe23d1e2',
            data: {
                text: '<p>Powered by Workflows</p>',
                position: 'middle-middle',
                color: '#838383',
                textPadding: 0,
                src: '',
                backgroundColor: '#F3F3F3',
                height: 50,
                fullWidth: false,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    ],
    inputVariables: [
        ...triggerFormContent.outputVariables,
        ...variables_1.sendMessageVariablesAsUnresolvedVariables,
    ],
    outputVariables: [],
};
const leaveApprovalEmail = {
    subject: 'Action required! <span data-variableid="602cb9b1-8158-4fec-a78e-02744ea38cab">Full Name</span> has submit a leave request.',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: 'd1debe47-b7e3-48f7-862e-5c08bba17081',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/pending_leave_request_678.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: '739d5756-e92d-4563-884a-beac0c14230d',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>Hi there,</p><p></p><p>A new leave request from <span data-variableid="602cb9b1-8158-4fec-a78e-02744ea38cab">Full Name</span> has been submitted.</p><p></p><p>Click the button below to review it for approval.</p>',
            },
        },
        {
            type: 'display-button',
            version: '1',
            id: '852b3dd0-0ad2-423c-b6c8-201db117cf55',
            data: {
                backgroundColor: '#FFFFFF',
                borderColor: '#2953A8',
                borderRadius: 20,
                buttonColor: '#2953A8',
                color: '#FFFFFF',
                fontSize: 14,
                href: '<span data-variableid="web_link">Web content link</span>',
                paddingBottom: 10,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 10,
                text: 'Review Leave Request',
                textAlign: 'center',
                width: 600,
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: 'fc090108-393b-4533-96ae-4c2b7bff989e',
            data: {
                text: '<p>Powered by Workflows</p>',
                position: 'middle-middle',
                color: '#838383',
                textPadding: 0,
                src: '',
                backgroundColor: '#F3F3F3',
                height: 50,
                fullWidth: false,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    ],
    inputVariables: [
        ...triggerFormContent.outputVariables,
        ...variables_1.sendMessageVariablesAsUnresolvedVariables,
    ],
    outputVariables: [],
};
const leaveApprovalWebform = {
    subject: 'Pending Leave Request',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: '38e7555a-2927-4660-b40d-232ee9cf7267',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/pending_leave_request_678.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: '83f8e1df-ea6d-4c87-8665-8b43c1332004',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<h3>Pending Approval</h3><p></p><p>Requested by: <span data-variableid="602cb9b1-8158-4fec-a78e-02744ea38cab">Full Name</span> &lt;<span data-variableid="8800edb3-90e2-4941-b959-9caf7334105b">Email Address</span>&gt;</p><p></p><p><strong>Date Created:</strong> <span data-variableid="date">Current date e.g: yyyy/mm/dd</span></p><p><strong>Details:</strong> <span data-variableid="602cb9b1-8158-4fec-a78e-02744ea38cab">Full Name</span> has requested <span data-variableid="88b8ac52-5bf5-45fb-b4c0-5795b02524d8">Leave Type</span> from <span data-variableid="f927f1ee-ea57-4664-b5d7-ad0cd73c4044">Leave Date Start</span> to <span data-variableid="9d34cd0c-6f96-4360-896b-a7a2c313f294">Leave Date End</span>.</p><p></p><p><strong>Commentary:</strong></p><p></p><p><span data-variableid="ef4a23b3-348e-468d-b360-e768ee3bfc46">Reason for leave</span></p>',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: '5ad87e87-d432-43e4-82f9-4586b5a41258',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'center',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p><strong>Please action the request below</strong></p>',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: 'cae9ecae-d452-4aeb-a225-f468ad68b4be',
            data: {
                backgroundColor: '#ffffff',
                label: 'Processed by',
                requiredField: true,
                helperText: 'The name of the person processing this request',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: '',
                textInputType: 'text',
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: 'c97b503b-42f3-4644-b33c-1f5b9e853753',
            data: {
                backgroundColor: '#ffffff',
                requiredField: true,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: 'Status',
                options: [
                    {
                        label: 'Approved',
                        id: '52e078f8-743d-461e-8a9f-b55b284a27f9',
                        value: true,
                    },
                    {
                        label: 'Denied',
                        id: '2cae8ccc-2299-4d19-82e1-b65c61e2904e',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-text-area',
            version: '1',
            id: '7d554d39-7431-49da-ad3a-0874c60d5da2',
            data: {
                backgroundColor: '#ffffff',
                label: 'Status Reason',
                requiredField: true,
                helperText: 'Please provide a reason for your decision.',
                defaultValue: '',
                inputFieldHeight: 4,
                placeholder: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
        {
            type: 'form-submit-button',
            version: '1',
            id: '26e81ec5-b3e7-41d3-b476-7626331b1f94',
            data: {
                backgroundColor: '#FFFFFF',
                borderColor: '#1515FF',
                borderRadius: 4,
                buttonColor: '#1515FF',
                color: '#FFFFFF',
                fontSize: 14,
                paddingBottom: 10,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 10,
                text: 'Process Request',
                textAlign: 'center',
                width: 600,
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: 'bbe184cd-f4df-4df0-93ed-efe6aa52dd1a',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>Upon submission, an email and SMS message with the status of the leave request will be sent to <span data-variableid="602cb9b1-8158-4fec-a78e-02744ea38cab">Full Name</span> &lt;<span data-variableid="8800edb3-90e2-4941-b959-9caf7334105b">Email Address</span>&gt; &lt;<span data-variableid="59ea92aa-9524-4b4b-a94b-22915c4623d7">Phone Number</span>&gt;.</p>',
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: '395d1368-28a2-45ff-b9b7-c8212c44e18f',
            data: {
                text: '<p>Powered by Workflows</p>',
                position: 'middle-middle',
                color: '#838383',
                textPadding: 0,
                src: '',
                backgroundColor: '#F1F1F1',
                height: 50,
                fullWidth: false,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    ],
    inputVariables: [
        ...triggerFormContent.outputVariables,
        ...variables_1.sendMessageVariablesAsUnresolvedVariables,
    ],
    outputVariables: [
        {
            id: 'cae9ecae-d452-4aeb-a225-f468ad68b4be',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Processed by',
        },
        {
            id: 'c97b503b-42f3-4644-b33c-1f5b9e853753',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: 'Status',
            options: [
                {
                    label: 'Approved',
                    id: '52e078f8-743d-461e-8a9f-b55b284a27f9',
                    value: true,
                },
                {
                    label: 'Denied',
                    id: '2cae8ccc-2299-4d19-82e1-b65c61e2904e',
                    value: false,
                },
            ],
        },
        {
            id: '7d554d39-7431-49da-ad3a-0874c60d5da2',
            valueType: 'string',
            inputType: 'form-text-area',
            label: 'Status Reason',
        },
    ],
    workspaceId: 'FAA4358B519D0E89',
};
const hrConfirmationRecordEmail = {
    subject: '<span data-variableid="602cb9b1-8158-4fec-a78e-02744ea38cab">Full Name</span>: Leave Request Status Record.',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: 'b6f83674-4015-4ace-8417-b2b58123d570',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/leave_request_status_record_678.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: 'd23cc691-c674-4ed6-bace-f51e92413f9a',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>This is an automated email record for <span data-variableid="602cb9b1-8158-4fec-a78e-02744ea38cab">Full Name</span> leave request.</p><p></p><h2>Original Request details</h2><p></p><p>Requested by: <span data-variableid="602cb9b1-8158-4fec-a78e-02744ea38cab">Full Name</span> &lt;<span data-variableid="8800edb3-90e2-4941-b959-9caf7334105b">Email Address</span>&gt;</p><p></p><p><strong>Details:</strong> <span data-variableid="602cb9b1-8158-4fec-a78e-02744ea38cab">Full Name</span> has requested <span data-variableid="88b8ac52-5bf5-45fb-b4c0-5795b02524d8">Leave Type</span> from <span data-variableid="f927f1ee-ea57-4664-b5d7-ad0cd73c4044">Leave Date Start</span> to <span data-variableid="9d34cd0c-6f96-4360-896b-a7a2c313f294">Leave Date End</span>.</p><p></p><p><strong>Commentary:</strong></p><p></p><p><span data-variableid="ef4a23b3-348e-468d-b360-e768ee3bfc46">Reason for leave</span></p><p></p><h2>Processed Details</h2><p></p><p><strong>Processed on: </strong><span data-variableid="date">Current date e.g: yyyy/mm/dd</span></p><p><strong>Leave request processed by:</strong> <span data-variableid="cae9ecae-d452-4aeb-a225-f468ad68b4be">Processed by</span></p><p><strong>Status: </strong><span data-variableid="c97b503b-42f3-4644-b33c-1f5b9e853753">Status</span></p><p><strong>Status Reason:</strong> <span data-variableid="7d554d39-7431-49da-ad3a-0874c60d5da2">Status Reason</span></p><p></p><p>An email and SMS message has been automatically sent to <span data-variableid="602cb9b1-8158-4fec-a78e-02744ea38cab">Full Name</span> &lt;<span data-variableid="8800edb3-90e2-4941-b959-9caf7334105b">Email Address</span>&gt; to communicate the status of their request.</p>',
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: '5eb57605-2613-4bc2-a214-f492fc54616e',
            data: {
                text: '<p>Powered by Workflows</p>',
                position: 'middle-middle',
                color: '#838383',
                textPadding: 0,
                src: '',
                backgroundColor: '#F3F3F3',
                height: 49,
                fullWidth: false,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    ],
    inputVariables: [
        ...triggerFormContent.outputVariables,
        ...leaveApprovalWebform.outputVariables,
        ...variables_1.sendMessageVariablesAsUnresolvedVariables,
    ],
    outputVariables: [],
};
const leaveRequestApprovedEmail = {
    subject: 'Your leave has been <span data-variableid="c97b503b-42f3-4644-b33c-1f5b9e853753">Status</span>!',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: 'fa8b1b9e-e066-4f41-bbbc-41be88dc50ce',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/Approved.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: '1704a5a5-0b3f-42f6-8f30-fc709cd512f3',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>Hi <span data-variableid="602cb9b1-8158-4fec-a78e-02744ea38cab">Full Name</span>,</p><p></p><p>Your leave request has been <span data-variableid="c97b503b-42f3-4644-b33c-1f5b9e853753">Status</span> by <span data-variableid="cae9ecae-d452-4aeb-a225-f468ad68b4be">Processed by</span> with the following reason:</p><p></p><p><span data-variableid="7d554d39-7431-49da-ad3a-0874c60d5da2">Status Reason</span></p><p></p><p>Kind Regards,</p><p></p><p>Human Resources</p><p>Acme Company</p>',
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: '5138f043-0a9c-4d42-8b9c-ae6846b82c02',
            data: {
                text: '<p>Powered by Workflows</p>',
                position: 'middle-middle',
                color: '#838383',
                textPadding: 0,
                src: '',
                backgroundColor: '#F3F3F3',
                height: 50,
                fullWidth: false,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    ],
    inputVariables: [
        ...triggerFormContent.outputVariables,
        ...leaveApprovalWebform.outputVariables,
        ...variables_1.sendMessageVariablesAsUnresolvedVariables,
    ],
    outputVariables: [],
};
const leaveRequestDeniedEmail = {
    subject: 'Your leave has been <span data-variableid="c97b503b-42f3-4644-b33c-1f5b9e853753">Status</span>.',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: 'c9b17458-5c4f-43db-b319-13824454be24',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/Denied.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: '23996bc2-1c15-4285-8018-33f3eb5fb4d5',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p>Hi <span data-variableid="602cb9b1-8158-4fec-a78e-02744ea38cab">Full Name</span>,</p><p></p><p>Your leave request has been <span data-variableid="c97b503b-42f3-4644-b33c-1f5b9e853753">Status</span> by <span data-variableid="cae9ecae-d452-4aeb-a225-f468ad68b4be">Processed by</span> with the following reason:</p><p></p><p><span data-variableid="7d554d39-7431-49da-ad3a-0874c60d5da2">Status Reason</span></p><p></p><p>Kind Regards,</p><p></p><p>Human Resources</p><p>Acme Company</p>',
            },
        },
        {
            type: 'display-banner',
            version: '1',
            id: '86b3e85e-6d16-47c6-9123-d25e8af7970b',
            data: {
                text: '<p>Powered by Workflows</p>',
                position: 'middle-middle',
                color: '#838383',
                textPadding: 0,
                src: '',
                backgroundColor: '#F3F3F3',
                height: 50,
                fullWidth: false,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    ],
    inputVariables: [
        ...triggerFormContent.outputVariables,
        ...leaveApprovalWebform.outputVariables,
        ...variables_1.sendMessageVariablesAsUnresolvedVariables,
    ],
    outputVariables: [],
};
const leaveRequestTemplate = (workspaceId, request) => __awaiter(void 0, void 0, void 0, function* () {
    return [
        {
            id: 0,
            variables: {
                input: [],
                output: [
                    {
                        type: 'FormTextInput',
                        variableId: '602cb9b1-8158-4fec-a78e-02744ea38cab',
                        variableName: 'Full Name',
                        variableType: 'string',
                    },
                    {
                        type: 'FormTextInput',
                        variableId: '59ea92aa-9524-4b4b-a94b-22915c4623d7',
                        variableName: 'Phone Number',
                        variableType: 'string',
                    },
                    {
                        type: 'FormTextInput',
                        variableId: '8800edb3-90e2-4941-b959-9caf7334105b',
                        variableName: 'Email Address',
                        variableType: 'string',
                    },
                    {
                        type: 'FormDropdown',
                        variableId: '2ce1a8ae-fac6-4eed-bd41-1c6a47a6fb18',
                        variableName: 'Department',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Accounts","checked":"false"},{"id":2,"text":"Human Resources","checked":"false"},{"id":3,"text":"Production","checked":"false"},{"id":"a74576a9-c506-48e4-95aa-ad042a4b1723","text":"Purchasing","checked":"false"},{"id":"9177902e-fb9e-4bf2-9865-876095efb052","text":"Sales","checked":"false"},{"id":"6ee2f629-dab3-41e4-83b2-3aa91d3c4a64","text":"Marketing","checked":"false"}]',
                    },
                    {
                        type: 'FormDropdown',
                        variableId: '88b8ac52-5bf5-45fb-b4c0-5795b02524d8',
                        variableName: 'Leave Type',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Annual Leave","checked":"false"},{"id":2,"text":"Personal or Sick Leave","checked":"false"},{"id":3,"text":"Birthday Leave","checked":"false"},{"id":"31d215a9-4695-4d29-ba51-5ba66490efb4","text":"Time in Lieu","checked":"false"},{"id":"7318e894-6edd-4c77-be6a-c7c24b95a6a3","text":"Compassionate Leave","checked":"false"},{"id":"07c0c651-5599-4476-90e1-7c025d25ed31","text":"Parental Leave","checked":"false"},{"id":"b46cbb09-4be4-402b-93ff-3e2dda80c2e0","text":"Unpaid Leave","checked":"false"},{"id":"4497b0dd-49c1-4c49-a432-13a0d9cd70f4","text":"Long Service Leave","checked":"false"}]',
                    },
                    {
                        type: 'FormDatePicker',
                        variableId: 'f927f1ee-ea57-4664-b5d7-ad0cd73c4044',
                        variableName: 'Leave Date Start',
                        variableType: 'date',
                    },
                    {
                        type: 'FormDatePicker',
                        variableId: '9d34cd0c-6f96-4360-896b-a7a2c313f294',
                        variableName: 'Leave Date End',
                        variableType: 'date',
                    },
                    {
                        type: 'FormTextArea',
                        variableId: 'ef4a23b3-348e-468d-b360-e768ee3bfc46',
                        variableName: 'Reason for leave',
                        variableType: 'string',
                    },
                ],
            },
            type: 'start',
            next: [
                {
                    id: 2600,
                    variables: {
                        input: [],
                        output: [],
                    },
                    type: 'task',
                    action: 'send-email',
                    next: [
                        {
                            id: 9553,
                            variables: {
                                input: [],
                                output: [
                                    {
                                        type: 'Recipient',
                                        variableId: '9553-internal-recipient-id',
                                        variableName: 'Recipient',
                                        variableType: 'recipient',
                                    },
                                    {
                                        type: 'Text',
                                        variableId: '9553-internal-recipient-firstname',
                                        variableName: 'Recipient: First Name',
                                        variableType: 'string',
                                    },
                                    {
                                        type: 'Text',
                                        variableId: '9553-internal-recipient-lastname',
                                        variableName: 'Recipient: Last Name',
                                        variableType: 'string',
                                    },
                                    {
                                        type: 'PhoneNumber',
                                        variableId: '9553-internal-recipient-mobilephone1',
                                        variableName: 'Recipient: Phone No.',
                                        variableType: 'string',
                                    },
                                    {
                                        type: 'EmailAddress',
                                        variableId: '9553-internal-recipient-emailaddress1',
                                        variableName: 'Recipient: Email',
                                        variableType: 'string',
                                    },
                                    {
                                        type: 'Date',
                                        variableId: '9553-internal-message-timestamp',
                                        variableName: 'Message: Time Sent',
                                        variableType: 'date',
                                    },
                                ],
                            },
                            type: 'task',
                            action: 'send-webform',
                            next: [
                                {
                                    id: 432,
                                    type: 'condition',
                                    action: 'on-webform-reply',
                                    variables: {
                                        input: [],
                                        output: [
                                            // {
                                            //   type: 'Date',
                                            //   variableId: '9553-internal-response-timestamp',
                                            //   variableName: 'Response: Time Received',
                                            //   variableType: 'date',
                                            // },
                                            {
                                                type: 'FormTextInput',
                                                variableId: 'cae9ecae-d452-4aeb-a225-f468ad68b4be',
                                                variableName: 'Processed by',
                                                variableType: 'string',
                                            },
                                            {
                                                type: 'FormRadioList',
                                                variableId: 'c97b503b-42f3-4644-b33c-1f5b9e853753',
                                                variableName: 'Status',
                                                variableType: 'string',
                                                options: '[{"id":1,"text":"Approved","checked":"true"},{"id":2,"text":"Denied","checked":"false"}]',
                                            },
                                            {
                                                type: 'FormTextArea',
                                                variableId: '7d554d39-7431-49da-ad3a-0874c60d5da2',
                                                variableName: 'Status Reason',
                                                variableType: 'string',
                                            },
                                        ],
                                    },
                                    next: [
                                        {
                                            id: 2017,
                                            variables: {
                                                input: [],
                                                output: [],
                                            },
                                            type: 'task',
                                            action: 'send-email',
                                            next: [
                                                {
                                                    id: 2531,
                                                    type: 'condition',
                                                    next: [
                                                        {
                                                            id: 8734,
                                                            variables: {
                                                                input: [],
                                                                output: [],
                                                            },
                                                            type: 'task',
                                                            action: 'send-sms',
                                                            next: [
                                                                {
                                                                    id: 1684,
                                                                    variables: {
                                                                        input: [],
                                                                        output: [],
                                                                    },
                                                                    type: 'task',
                                                                    action: 'send-email',
                                                                    next: null,
                                                                    isDirty: true,
                                                                    version: '1.0.4',
                                                                    data: {
                                                                        workspaceId,
                                                                        recipients: [
                                                                            {
                                                                                type: 'variable',
                                                                                stepId: '0',
                                                                                variableId: '8800edb3-90e2-4941-b959-9caf7334105b',
                                                                            },
                                                                        ],
                                                                        message: {
                                                                            content: yield (0, templateUtils_1.getContentData)({
                                                                                request: () => __awaiter(void 0, void 0, void 0, function* () {
                                                                                    return request(Object.assign(Object.assign({}, leaveRequestApprovedEmail), { workspaceId }));
                                                                                }),
                                                                            }),
                                                                            type: 'email',
                                                                        },
                                                                        link: null,
                                                                        collectResponses: false,
                                                                        stepName: 'Leave Request Approved',
                                                                    },
                                                                },
                                                            ],
                                                            isDirty: true,
                                                            version: '1.0.4',
                                                            data: {
                                                                workspaceId,
                                                                recipients: [
                                                                    {
                                                                        type: 'variable',
                                                                        stepId: '0',
                                                                        variableId: '59ea92aa-9524-4b4b-a94b-22915c4623d7',
                                                                    },
                                                                ],
                                                                message: {
                                                                    content: {
                                                                        type: 'raw',
                                                                        subject: '<p>SMS Leave Request Approved</p>',
                                                                        body: '<p>Hi <span data-stepid="0" data-variableid="602cb9b1-8158-4fec-a78e-02744ea38cab">Full Name</span>,</p><p></p><p>Your leave request, from <span data-stepid="0" data-variableid="f927f1ee-ea57-4664-b5d7-ad0cd73c4044">Leave Date Start</span> to <span data-stepid="0" data-variableid="9d34cd0c-6f96-4360-896b-a7a2c313f294">Leave Date End</span>  has been <span data-stepid="432" data-variableid="c97b503b-42f3-4644-b33c-1f5b9e853753">Status</span> by <span data-stepid="432" data-variableid="cae9ecae-d452-4aeb-a225-f468ad68b4be">Processed by</span> with the following reason:</p><p></p><p><span data-stepid="432" data-variableid="7d554d39-7431-49da-ad3a-0874c60d5da2">Status Reason</span></p><p></p><p>Kind Regards,</p><p>Human Resources</p><p>Acme. Company</p>',
                                                                    },
                                                                    type: 'sms',
                                                                },
                                                                link: null,
                                                                collectResponses: false,
                                                                stepName: 'SMS Leave Request Approved',
                                                            },
                                                        },
                                                    ],
                                                    action: 'expression',
                                                    isDirty: true,
                                                    variables: {
                                                        input: [],
                                                        output: [],
                                                    },
                                                    version: '1.0.1',
                                                    data: {
                                                        stepName: 'IF Condition',
                                                        expression: {
                                                            id: 'dda01b31-cbbb-4aa7-8b13-9bf97155c8d6',
                                                            type: 'expression',
                                                            operator: 'equals',
                                                            right: {
                                                                type: 'constant',
                                                                value: 'Approved',
                                                                valueType: 'string',
                                                            },
                                                            left: {
                                                                type: 'variable',
                                                                variableId: 'c97b503b-42f3-4644-b33c-1f5b9e853753',
                                                                stepId: '432',
                                                            },
                                                        },
                                                    },
                                                },
                                                {
                                                    id: 3436,
                                                    type: 'condition',
                                                    next: [
                                                        {
                                                            id: 8096,
                                                            variables: {
                                                                input: [],
                                                                output: [],
                                                            },
                                                            type: 'task',
                                                            action: 'send-sms',
                                                            next: [
                                                                {
                                                                    id: 935,
                                                                    variables: {
                                                                        input: [],
                                                                        output: [],
                                                                    },
                                                                    type: 'task',
                                                                    action: 'send-email',
                                                                    next: null,
                                                                    isDirty: true,
                                                                    version: '1.0.4',
                                                                    data: {
                                                                        workspaceId,
                                                                        recipients: [
                                                                            {
                                                                                type: 'variable',
                                                                                stepId: '0',
                                                                                variableId: '8800edb3-90e2-4941-b959-9caf7334105b',
                                                                            },
                                                                        ],
                                                                        message: {
                                                                            content: yield (0, templateUtils_1.getContentData)({
                                                                                request: () => __awaiter(void 0, void 0, void 0, function* () {
                                                                                    return request(Object.assign(Object.assign({}, leaveRequestDeniedEmail), { workspaceId }));
                                                                                }),
                                                                            }),
                                                                            type: 'email',
                                                                        },
                                                                        link: null,
                                                                        collectResponses: false,
                                                                        stepName: 'Leave Request Denied',
                                                                    },
                                                                },
                                                            ],
                                                            isDirty: true,
                                                            version: '1.0.4',
                                                            data: {
                                                                workspaceId,
                                                                recipients: [
                                                                    {
                                                                        type: 'variable',
                                                                        stepId: '0',
                                                                        variableId: '59ea92aa-9524-4b4b-a94b-22915c4623d7',
                                                                    },
                                                                ],
                                                                message: {
                                                                    content: {
                                                                        type: 'raw',
                                                                        subject: '<p>SMS Leave Request Denied</p>',
                                                                        body: '<p>Hi <span data-stepid="0" data-variableid="602cb9b1-8158-4fec-a78e-02744ea38cab">Full Name</span>,</p><p></p><p>Unfortunately your leave request from <span data-stepid="0" data-variableid="f927f1ee-ea57-4664-b5d7-ad0cd73c4044">Leave Date Start</span> to <span data-stepid="0" data-variableid="9d34cd0c-6f96-4360-896b-a7a2c313f294">Leave Date End</span> has been <span data-stepid="432" data-variableid="c97b503b-42f3-4644-b33c-1f5b9e853753">Status</span>by <span data-stepid="432" data-variableid="cae9ecae-d452-4aeb-a225-f468ad68b4be">Processed by</span> with the following reason:</p><p></p><p><span data-stepid="432" data-variableid="7d554d39-7431-49da-ad3a-0874c60d5da2">Status Reason</span></p><p></p><p>Kind Regards,</p><p>The HR Team</p>',
                                                                    },
                                                                    type: 'sms',
                                                                },
                                                                link: null,
                                                                collectResponses: false,
                                                                stepName: 'SMS Leave Request Denied',
                                                            },
                                                        },
                                                    ],
                                                    action: 'expression',
                                                    isDirty: true,
                                                    variables: {
                                                        input: [],
                                                        output: [],
                                                    },
                                                    version: '1.0.1',
                                                    data: {
                                                        stepName: 'IF Condition',
                                                        expression: {
                                                            id: '159be2e3-6053-4986-ac3e-893c03a105de',
                                                            type: 'expression',
                                                            operator: 'equals',
                                                            right: {
                                                                type: 'constant',
                                                                value: 'Denied',
                                                                valueType: 'string',
                                                            },
                                                            left: {
                                                                type: 'variable',
                                                                variableId: 'c97b503b-42f3-4644-b33c-1f5b9e853753',
                                                                stepId: '432',
                                                            },
                                                        },
                                                    },
                                                },
                                            ],
                                            isDirty: true,
                                            version: '1.0.4',
                                            data: {
                                                workspaceId,
                                                recipients: [
                                                    {
                                                        type: 'variable',
                                                        stepId: '0',
                                                        variableId: '8800edb3-90e2-4941-b959-9caf7334105b',
                                                    },
                                                ],
                                                message: {
                                                    content: yield (0, templateUtils_1.getContentData)({
                                                        request: () => __awaiter(void 0, void 0, void 0, function* () {
                                                            return request(Object.assign(Object.assign({}, hrConfirmationRecordEmail), { workspaceId }));
                                                        }),
                                                    }),
                                                    type: 'email',
                                                },
                                                link: null,
                                                collectResponses: false,
                                                stepName: 'HR Confirmation Record',
                                            },
                                        },
                                    ],
                                    isDirty: true,
                                    version: '1.0.0',
                                    data: {
                                        stepName: 'Replies For: Web Form 1',
                                        token: {
                                            variableId: '9553-internal-token',
                                            stepId: 9553,
                                            valueType: 'string',
                                        },
                                        collectResponses: {
                                            duration: {
                                                days: 3,
                                                hours: 0,
                                                minutes: 0,
                                            },
                                        },
                                    },
                                },
                                {
                                    id: 5988,
                                    type: 'condition',
                                    action: 'on-webform-no-reply',
                                    variables: {
                                        input: [],
                                        output: [],
                                    },
                                    next: null,
                                    isDirty: true,
                                    version: '1.0.0',
                                    data: {
                                        stepName: 'No Replies For: Web Form 1',
                                        token: {
                                            variableId: '9553-internal-token',
                                            stepId: 9553,
                                            valueType: 'string',
                                        },
                                        collectResponses: {
                                            duration: {
                                                days: 3,
                                                hours: 0,
                                                minutes: 0,
                                            },
                                        },
                                    },
                                },
                            ],
                            isDirty: true,
                            version: '1.0.1',
                            data: {
                                workspaceId,
                                recipients: [
                                    {
                                        type: 'adhoc',
                                        value: 'hr@company.com',
                                    },
                                ],
                                message: {
                                    content: yield (0, templateUtils_1.getContentData)({
                                        request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, leaveApprovalEmail), { workspaceId })); }),
                                    }),
                                    type: 'email',
                                },
                                link: {
                                    type: 'web',
                                    content: yield (0, templateUtils_1.getContentData)({
                                        request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, leaveApprovalWebform), { workspaceId })); }),
                                    }),
                                },
                                stepName: 'Leave Approval Webform',
                                collectResponses: true,
                            },
                        },
                    ],
                    isDirty: true,
                    version: '1.0.4',
                    data: {
                        workspaceId,
                        recipients: [
                            {
                                type: 'variable',
                                stepId: '0',
                                variableId: '8800edb3-90e2-4941-b959-9caf7334105b',
                            },
                        ],
                        message: {
                            content: yield (0, templateUtils_1.getContentData)({
                                request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, leaveRequestConfirmationEmail), { workspaceId })); }),
                            }),
                            type: 'email',
                        },
                        link: null,
                        collectResponses: false,
                        stepName: 'Leave Request Confirmation',
                    },
                },
            ],
            isDirty: true,
            version: '1.0.2',
            data: {
                stepName: 'Trigger',
                triggers: [
                    {
                        id: 0,
                        type: 'form',
                        data: {
                            form: yield (0, templateUtils_1.getContentData)({
                                request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, triggerFormContent), { workspaceId })); }),
                            }),
                        },
                    },
                ],
            },
        },
    ];
});
exports.leaveRequestTemplate = leaveRequestTemplate;
//# sourceMappingURL=leaveRequest.js.map